import { render } from "./AlterWall40Component.vue?vue&type=template&id=69b3f7c2&scoped=true"
import script from "./AlterWall40Component.vue?vue&type=script&lang=js"
export * from "./AlterWall40Component.vue?vue&type=script&lang=js"

import "./AlterWall40Component.vue?vue&type=style&index=0&id=69b3f7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b3f7c2"]])

export default __exports__